import type { UUID } from '@/utils/uuid';

export const engineQueryKeys = {
  evaluatorLists: () => ['evaluators'] as const,
  evaluatorList: (tenantId?: UUID, limit?: number, filter?: string) =>
    ['evaluators', tenantId, limit ?? null, filter ?? null] as const,
  evaluatorListByTenant: (tenantId?: UUID) => ['evaluators', tenantId] as const,
  evaluatorDetail: (tenantId?: UUID, ruleId?: UUID) =>
    ['evaluator', tenantId, ruleId] as const,

  automationLists: () => ['automations'] as const,
  automationList: (tenantId?: UUID, limit?: number, filter?: string) =>
    ['automations', tenantId, limit ?? null, filter ?? null] as const,
  automationListByTenant: (tenantId?: UUID) =>
    ['automations', tenantId] as const,
  automationDetail: (tenantId?: UUID, ruleId?: UUID) =>
    ['automation', tenantId, ruleId] as const,
};

export const evaluatorMutationKeys = {
  createEvaluator: (tenantId?: UUID) => ['createEvaluator', tenantId] as const,
  updateEvaluator: (tenantId?: UUID, ruleId?: UUID) =>
    ['updateEvaluator', tenantId, ruleId] as const,
  deleteEvaluator: (tenantId?: UUID) => ['deleteEvaluator', tenantId] as const,
};
